<template>
  <div>
    <div class="overflow-auto w-full pb-12">
      <div
        class="steps has-content-centered px-0 pr-4 md:pr-0 md:px-6 flex items-center left-0 justify-center relative mt-4"
      >
        <a
          v-for="tab in tabs"
          :key="tab.name"
          class="steps-segment flex justify-center items-center flex-col w-1/6 relative"
          :class="{ 'is-active': tab.isActive, 'is-completed': tab.isComplete }"
        >
          <div
            class="steps-marker flex relative text-center items-center flex-col w-full first:bg-red"
          >
            <div class="px-3 bg-white">
              <i
                class="circle h-12 w-12 bg-gray-500 rounded-full flex justify-center items-center mb-3"
                :class="tab.icon"
              ></i>
            </div>
            <div class="steps-content absolute w-full">
              <p class="is-size-4 text-center text-sm text-gray-900 font-semibold">{{ tab.name }}</p>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="tab-details -mt-4">
      <slot :formData="formData" />
    </div>
    <br />
    <div class="field is-grouped">
      <div
        v-if="currentActive == 0 && totalTabs !== 1"
        class="control flex flex-col items-center w-full justify-center px-6 md:px-0"
      >
        <button
          class="next-button button is-link bg-pink-500 hover:bg-white text-center text-white hover:text-pink-500 font-bold rounded w-full md:w-1/3 border hover:border-pink-500 focus:outline-none py-3"
          :disabled="isValidating"
          @click="emailValidation()"
        >{{ $t('messages.general.create_profile') }}</button>
        <small
          v-show="hasErrors"
          class="text-red-500 mt-4 font-bold"
        >{{ $t('messages.general.complete_fields') }}</small>
      </div>
      <div
        v-else-if="currentActive > 0 && currentActive !== totalTabs -1"
        class="control flex flex-col items-center w-full justify-center px-6 md:px-0"
      >
        <button
          class="next-button button is-link bg-pink-500 hover:bg-white text-center text-white hover:text-pink-500 font-bold rounded w-full md:w-1/3 border hover:border-pink-500 focus:outline-none py-3"
          :disabled="isValidating"
          @click="nextTab()"
        >{{ $t('messages.general.save_and_continue') }}</button>
        <small
          v-show="hasErrors"
          class="text-red-500 mt-4 font-bold"
        >{{ $t('messages.general.complete_fields') }}</small>
      </div>

      <div
        v-if="currentActive == totalTabs - 1"
        class="control control flex flex-col items-center w-full justify-center"
      >
        <button
          class="next-button button is-link bg-pink-500 hover:bg-white text-center text-white hover:text-pink-500 font-bold rounded w-full md:w-1/3 border hover:border-pink-500 focus:outline-none py-3 h-12"
          :disabled="isLoading"
          @click.prevent="submit()"
        >{{ $t('messages.general.save_and_finish') }}</button>
        <vue-element-loading
          :active="isLoading"
          spinner="spinner"
          color="#DBDBDB"
          background-color="rgba(255, 255, 255, .5)"
        />
        <small
          v-show="hasErrors"
          class="text-red-500 mt-4 font-bold"
        >{{ $t('messages.general.complete_fields') }}</small>
      </div>
    </div>

    <transition name="modal">
      <div v-if="emailConfirm">
        <div
          class="z-50 flex items-center justify-center w-full h-full overlay"
          @click.self="closeVerifyModal()"
        >
          <div
            class="overflow-auto flex flex-col items-center justify-center w-full md:w-1/2 p-6 mx-auto my-0 bg-white rounded-lg modal"
         >
            <h3
              class="text-xl text-center md:text-3xl font-bold text-blue-500"
            >{{ $t('messages.emailconfirm.title') }}</h3>
            <p
              class="my-2 text-sm md:text-base md:my-6 font-semibold text-center text-gray-900"
            >{{ $t('messages.emailconfirm.description', {email}) }}</p>
            <div class="mb-4">
              <input type="text" v-model="token" name="token" class="block w-full h-12 px-4 mt-2 font-semibold text-gray-700 border border-blue-500 rounded outline-none">
            </div>
            <div class="w-full text-center mb-4">
              {{ $t('messages.emailconfirm.legend') }}
            </div>
            <div class="flex justify-center w-full mb-4">
              <div>
                <a
                  href="#"
                  @click.prevent="doEmailVerify()"
                  class="px-6 py-2 mx-4 text-sm font-semibold text-white no-underline bg-blue-700 rounded"
                >{{ $t('messages.emailconfirm.button') }}</a>
              </div>
            </div>
            <div class="w-full text-center mb-4">
              <strong>{{ $t('messages.emailconfirm.help_message') }}</strong>
              <p>{{ $t('messages.emailconfirm.verify') }} <a class="text-red-600 font-bold" href="#" @click.prevent="resendEmailConfirm()">{{ $t('messages.emailconfirm.resend') }}</a></p>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import bus from "@/bus";

export default {
  name: "FormWizard",

  props: {
    isLoading: Boolean
  },

  data() {
    return {
      tabs: [],
      currentActive: 0,
      totalTabs: 0,
      isValidating: false,
      hasErrors: false,
      emailConfirm: false,
      token: null,
      email: null,
      comfirmCounter: 0,
      hasPhotos: false,
      choosedGender: null,
      formData: {
        name: "",
        email: "",
        about: "",
        gender: "",
        reference: "",
        terms: ""
      },
      picturesTab: null
    };
  },

  created() {
    this.tabs = this.$children;
  },
  mounted() {
    this.tabs = this.$children.filter(
      component => component.$options.name === "Tab"
    );

    this.picturesTab = this.tabs[3].$children[0];

    this.totalTabs = this.tabs.length;

    bus.$on('uploaded-photos', photos => {
      if (photos.length > 0) {
        this.hasPhotos = true;
      } else {
        this.hasPhotos = false;
      }
    });

    bus.$on('choosed-gender', gender => {
      this.choosedGender = gender;
    });
  },
  computed: {
    ...mapState("locale", ["locale"]),
  },
  methods: {
    ...mapActions("auth", ['sendEmailConfirm', 'verifyEmailCode']),
    closeVerifyModal() {
      this.emailConfirm = false;

      setTimeout(() => {
        bus.$emit('email-verification', false);
      })
    },
    emailValidation() {
      setTimeout(async () => {
        if (this.isValidating) {
          return;
        }

        this.isValidating = true;

        // Validate input
        if (
          await this.$root.$validator.validate(`step${this.currentActive + 1}.*`)
        ) {

          const stepOne = this.tabs[this.currentActive].$children[0];
          const email = stepOne.form.email;
          this.email = email;

          await this.sendEmailConfirm(this.email);
          this.hasErrors = false;
          this.emailConfirm = true;
          bus.$emit('email-verification', true);
        } else {
          this.hasErrors = true;
        }
        this.isValidating = false;
      });
    },
    async resendEmailConfirm() {
      await this.sendEmailConfirm(this.email);

      this.comfirmCounter = 0;

      this.$toasted.show(this.$t('messages.emailconfirm.resendMessage'), {
        type: 'success',
        duration: 3000,
        position: 'bottom-right',
      });
    },
    async doEmailVerify() {
      this.comfirmCounter += 1;

      const params = {
        email: this.email,
        token: parseInt(this.token, 10)
      }

      const response = await this.verifyEmailCode(params);

      if (response.status === 'ok') {
        this.nextTab();
        setTimeout(() => {
          this.emailConfirm = false;
        })
      } else {
        if (this.comfirmCounter >= 5) {
          this.comfirmCounter = 0;
          this.token = null;

          this.$toasted.show(this.$t('messages.emailconfirm.exceeded'), {
            type: 'error',
            duration: 6000,
            position: 'bottom-right',
          });

          this.$router.push({
            name: 'home',
            params: {
              lang: this.locale
            }
          });
        } else {
          this.$toasted.show(this.$t('messages.emailconfirm.verifyError'), {
            type: 'error',
            duration: 6000,
            position: 'bottom-right',
          });
        }
      }
    },
    previousTab() {
      this.tabs[this.currentActive].isComplete = false;
      this.$emit("changed", this.currentActive);
      this.currentActive--;
      this.tabs.forEach(tab => {
        tab.isActive = false;
      });
      this.tabs[this.currentActive].isActive = true;
    },

    async nextTab() {
      if (this.isValidating) {
        return;
      }

      this.isValidating = true;

      // Check if photo was uploaded
      if (!this.hasPhotos && this.currentActive === 3) {
        //this.hasErrors = true;
        this.isValidating = false;
        bus.$emit('user-no-photos', 'empty');
        return;
      }

      if (this.hasPhotos && this.currentActive === 3) {

        // Waiting for photos to be uploaded
        const photos = await this.picturesTab.getData('wizard');

        Promise.all(photos).then(pictures => {
          if (pictures.length <= 0) {
            this.isValidating = false;
            bus.$emit('user-no-photos', 'error');
            return;
          }

          this.isValidating = false;
          bus.$emit('photos-uploaded', pictures);
          this.tabs[this.currentActive].isComplete = true;
          this.currentActive++;
          this.tabs.forEach(tab => {
            tab.isActive = false;
          });
          this.tabs[this.currentActive].isActive = true;
          window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
          });
          this.hasErrors = false;
        });

        return;
      }

      // Validate input
      if (
        await this.$root.$validator.validate(`step${this.currentActive + 1}.*`)
      ) {

        this.tabs[this.currentActive].isComplete = true;
        this.$emit("changed", this.currentActive);
        this.currentActive++;
        this.tabs.forEach(tab => {
          tab.isActive = false;
        });
        this.tabs[this.currentActive].isActive = true;
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
        this.hasErrors = false;
      } else {
        this.hasErrors = true;
      }
      this.isValidating = false;
    },

    async submit() {
      try {
        if (this.isValidating) {
          return;
        }

        this.isValidating = true;
        if (await this.$root.$validator.validate(`step${this.totalTabs}.*`)) {
          this.$emit("finished");
          this.hasErrors = false;
        } else {
          this.hasErrors = true;
        }
        this.isValidating = false;
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>
<style lang="scss" scope>
.next-button:disabled {
  cursor: default;
  opacity: 0.5;
}

.steps a::after {
  content: "";
  position: absolute;
  width: 50%;
  height: 2px;
  background-color: #dddddd;
  left: -25%;
}
.steps a:first-child::after {
  content: none;
}
.steps a.is-active {
  &::after {
    background-color: #f35a78;
  }
}

.steps a.is-completed .circle {
  background: #71BD10;
  color: white !important;
  opacity: 1;
}

.steps {
  @media screen and(max-width: 768px) {
    width: 800px;
  }
  a {
    i {
      opacity: 0.6;
    }
    .is-size-4 {
      opacity: 0.6;
    }
  }
  a.is-active {
    opacity: 1;
    cursor: default;

    i {
      opacity: 1;
    }
    .is-size-4 {
      opacity: 1;
    }
  }
}
.steps a.is-active .circle {
  background-color: #f35a78 !important;
  color: white !important;
}
.steps-content {
  top: 90%;
  width: 100%;
}
.bg-gray-500 {
  background-color: #dddddd;
}
</style>
